module.exports = __webpack_public_path__ + "assets/img/8368e7e8c338043aee5c0966efe057f0.svg";